var InvitedList = [
  {
    id: 0,
    name: 'Been Kim',
    image: 'beenkim',
    affiliation: 'Google Brain',
    link: 'https://beenkim.github.io/',
  },
  {
    id: 1,
    name: 'Steve Chien',
    image: 'stevechien',
    affiliation: 'NASA Jet Propulsion Lab, California Institute of Technology',
    link: 'https://ai.jpl.nasa.gov/public/people/chien/',
  },
  {
    id: 2,
    name: 'Dan Weld',
    image: 'danweld',
    affiliation: 'University of Washington',
    link: 'https://www.cs.washington.edu/people/faculty/weld',
  },
];

var PanelList = [
  {
    id: 0,
    name: 'Been Kim',
    image: 'beenkim',
    affiliation: 'Google Brain',
    link: 'https://beenkim.github.io/',
  },
  {
    id: 1,
    name: 'Steve Chien',
    image: 'stevechien',
    affiliation: 'NASA Jet Propulsion Lab',
    link: 'https://ai.jpl.nasa.gov/public/people/chien/',
  },
  {
    id: 2,
    name: 'Dan Weld',
    image: 'danweld',
    affiliation: 'University of Washington',
    link: 'https://www.cs.washington.edu/people/faculty/weld',
  },
  {
    id: 3,
    name: 'Alan Fern',
    image: 'alan',
    affiliation: 'Oregon State University',
    link: 'https://eecs.oregonstate.edu/people/fern-alan',
  },
];

var MemberListCache = [
  {
    id: 0,
    name: 'Tathagata Chakraborti',
    image: 'tathagata',
    affiliation: 'IBM Research AI',
    link: 'http://tchakra2.com',
  },
  {
    id: 1,
    name: 'Alan Lindsay',
    image: 'alanL',
    affiliation: 'Heriot-Watt University',
    link: 'https://scholar.google.co.uk/citations?user=FA9LGEwAAAAJ&hl=en',
  },
  {
    id: 2,
    name: 'Joerg Hoffmann',
    image: 'joerg',
    affiliation: 'Saarland University',
    link: 'http://fai.cs.uni-saarland.de/hoffmann/',
  },
  {
    id: 15,
    name: 'Stylianos Vasileiou',
    image: 'stylianos',
    affiliation: 'Washington University',
    link: 'https://thestlucas.com/',
  },
  {
    id: 18,
    name: 'Benjamin Krarup',
    image: 'ben',
    affiliation: 'Kings College London',
    link: 'https://uk.linkedin.com/in/benjamin-krarup',
  },
  {
    id: 14,
    name: 'Rebecca Eifler',
    image: 'rebecca',
    affiliation: 'Saarland University',
    link: 'http://fai.cs.uni-saarland.de/eifler/',
  },
  {
    id: 6,
    name: 'Silvia Tulli',
    image: 'silvia',
    affiliation: 'Sorbonne University',
    link: 'https://silviatulli.com/',
  },
  {
    id: 7,
    name: 'Sarath Sreedharan',
    image: 'sarath',
    affiliation: 'Arizona State University',
    link: 'http://www.public.asu.edu/~ssreedh3/',
  },
];

var PCListCache = [
  {
    id: 1,
    name: 'Zahra Zahedi',
    affiliation: 'Arizona State University',
  },
  {
    id: 2,
    name: 'Sachin Grover',
    affiliation: 'Arizona State University',
  },
  {
    id: 3,
    name: 'Sriram Gopalakrishnan',
    affiliation: 'Arizona State University',
  },
  {
    id: 4,
    name: 'Raymond Sheh',
    affiliation: 'Georgetown University',
  },
  {
    id: 5,
    name: 'Ramon Fraga Pereira',
    affiliation: 'Sapienza University of Rome',
  },
  {
    id: 6,
    name: 'Pulkit Verma',
    affiliation: 'Arizona State University',
  },
  {
    id: 7,
    name: 'Mudit Verma',
    affiliation: 'Arizona State University',
  },
  {
    id: 8,
    name: 'Aaquib Tabrez',
    affiliation: 'University of Colorado',
  },
  {
    id: 9,
    name: 'Maurício Cecílio Magnaguagno',
    affiliation: 'Pontifical Catholic University of Rio Grande do Sul',
  },
  {
    id: 10,
    name: 'Martim Brandão',
    affiliation: "King's College London",
  },
  {
    id: 11,
    name: 'Maayan Shvo',
    affiliation: 'University of Toronto',
  },
  {
    id: 12,
    name: 'Isaac Lage',
    affiliation: 'Harvard University',
  },
  {
    id: 13,
    name: 'Giovanni Ciatto',
    affiliation: 'University of Bologna',
  },
  {
    id: 14,
    name: 'Gerard Canal',
    affiliation: "King's College London",
  },
  {
    id: 15,
    name: 'Felix Lindner',
    affiliation: 'Ulm University',
  },
  {
    id: 16,
    name: 'Fabio Mercorio',
    affiliation: 'University of Milano-Bicocca',
  },
  {
    id: 17,
    name: 'Ashwin Kumar',
    affiliation: 'Washington University in St. Louis',
  },
  {
    id: 18,
    name: 'Prashan Madumal',
    affiliation: 'The University of Melbourne',
  },
  {
    id: 19,
    name: 'Pascal Tobias Bercher',
    affiliation: 'Australian National University',
  },
  {
    id: 20,
    name: 'Liz Sonenberg',
    affiliation: 'The University of Melbourne',
  },
  {
    id: 21,
    name: 'Joseph Kim',
    affiliation: 'Massachusetts Institute of Technology',
  },
  {
    id: 22,
    name: 'Anna Collins',
    affiliation: "King's College London",
  },
  {
    id: 23,
    name: 'S.T. Lin',
    affiliation: 'Australian National University',
  },
];

export { MemberListCache, PCListCache, InvitedList, PanelList };
